import { render, staticRenderFns } from "./EmailCode.vue?vue&type=template&id=9defb5a8&"
import script from "./EmailCode.vue?vue&type=script&lang=ts&"
export * from "./EmailCode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports